import { createSlice } from '@reduxjs/toolkit';
import { CashHistoryType } from '@src/types/cash';
import { getCashHistory, refundCash } from './cashHistoryThunk';
import { CashModalType } from '../types';

interface CashHistoryState {
  loading: boolean;
  modal: CashModalType;
  selected: CashHistoryType | undefined;
  cashHistory: CashHistoryType[];
  meta: {
    totalPages: number;
    currentPage: number;
    itemsPerPage: number;
    totalItems: number;
  };
  params?: {
    page?: number;
    limit?: number;
    sortBy?: string[];
    searchBy?: string[];
    search?: string;
    filter?: {
      status?: string;
      type?: string;
      company?: { id?: string };
      user?: { id?: string };
    };
  };
}

const initialState: CashHistoryState = {
  loading: false,
  cashHistory: [],
  selected: undefined,
  modal: 'off',
  meta: {
    totalPages: 0,
    currentPage: 0,
    itemsPerPage: 0,
    totalItems: 0,
  },
  params: {
    page: 1,
    limit: 20,
    sortBy: undefined,
    searchBy: undefined,
    search: undefined,
    filter: {
      status: undefined,
      type: undefined,
      company: {
        id: undefined,
      },
      user: {
        id: undefined,
      },
    },
  },
};

const cashHistorySlice = createSlice({
  name: 'chargeHistory',
  initialState,
  reducers: {
    onChangeSortBy(state, { payload }) {
      state.params = { ...state.params, ...payload };
    },
    onChangePage(state, { payload }) {
      state.params.page = payload;
    },
    onChangeSearchOption: (state, { payload }) => {
      state.params.searchBy = payload;
    },
    onChangeSearch: (state, { payload }) => {
      state.params.search = payload;
    },
    onChangeModal(state, { payload }) {
      state.modal = payload;
    },
    onChangeSelected(state, { payload }) {
      state.selected = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCashHistory.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCashHistory.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.cashHistory = payload.data;
        state.meta = payload.meta;
      })
      .addCase(getCashHistory.rejected, (state) => {
        state.loading = false;
      });
    builder.addCase(refundCash.fulfilled, (state) => {
      state.params.page = 1;
    });
  },
});

export const {
  onChangeSortBy,
  onChangePage,
  onChangeSearchOption,
  onChangeSearch,
  onChangeModal,
  onChangeSelected,
} = cashHistorySlice.actions;
export default cashHistorySlice.reducer;
